import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { reactionListDriverFactory } from './ReactionList/ReactionList.driver';
import {
  dataHook,
  dataHookContains,
  hasMobile,
} from '../../testkitUtils/utils';
import { ReactionsDataHooks } from './dataHooks';
import { focusable, privateMixin } from '../../test/unidriver-mixins';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';

export const reactionsDriverFactory = (base: UniDriver, body: UniDriver) => {
  const triggerButton = base.$(
    dataHookContains(ReactionsDataHooks.TriggerButton),
  );
  const subTriggerButton = base.$(
    dataHook(ReactionsDataHooks.SubTriggerButton),
  );
  const clickTriggerButton = async () => triggerButton.click();
  const hoverTriggerButton = async () => triggerButton.hover();
  const focusTriggerButton = async () =>
    triggerButton.getNative().then((el) => el.focus());

  return {
    ...reactionListDriverFactory(base),
    focused: (() => {
      const focusBase = body.$(`:focus`);
      const privateDriver = privateMixin(focusBase);

      return {
        ...privateDriver,
        ...baseUniDriverFactory(focusBase),
        attr: privateDriver._base.attr,
        pressKey: privateDriver._base.pressKey,
      };
    })(),
    triggerButton: {
      ...baseUniDriverFactory(triggerButton),
      ...focusable(triggerButton),
    },
    subTriggerButton: {
      ...baseUniDriverFactory(subTriggerButton),
      ...focusable(subTriggerButton),
    },
    /* TODO: JB: it should reuse popover driver */
    popover: (() => {
      const popoverBase = base.$(dataHook(ReactionsDataHooks.PopoverContent));

      return {
        ...privateMixin(popoverBase),
        ...baseUniDriverFactory(popoverBase),
      };
    })(),
    getTriggerButton: async () => triggerButton,
    getSubTriggerButton: async () => subTriggerButton,
    getReactionLabel: async () =>
      base.$(dataHook(ReactionsDataHooks.ReactionLabel)).text(),
    isOpen: async () =>
      base.$(dataHook(ReactionsDataHooks.PopoverContent)).exists(),
    clickTriggerButton,
    hoverTriggerButton,
    focusTriggerButton,
    openReactionList: async () => {
      const isMobile = await hasMobile(base);
      if (isMobile) {
        await clickTriggerButton();
      } else {
        await hoverTriggerButton();
      }
    },
  };
};

export type ReactionsDriver = ReturnType<typeof reactionsDriverFactory>;
